module.exports = __webpack_public_path__ + "static/img/happy-money.70cce46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customer/happy-money.png
// module id = BLCz
// module chunks = 1